import _isEmpty from 'lodash/isEmpty';

/**
 * Used as a helper function to validate if window.nodeChat.show() is present, this function is used in conjunction with poll.js
 * @returns {*}
 */

const nodeChatOnPageValidator = () => {
  if (_isEmpty(window.nodeChat) || (typeof window.nodeChat.show !== 'function')) {
    return Promise.reject(false);
  }
  return Promise.resolve(window.nodeChat);
};


const asyncChatValidator = () => {
  if (typeof window.nodeChat === 'undefined' || typeof window.nodeChat.showAsync !== 'function') {
    return Promise.reject();
  }
  return Promise.resolve();
};

module.exports = {
  asyncChatValidator,
  nodeChatOnPageValidator,
};
